<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 10 16"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9.15827 7.25235C9.60615 7.65017 9.60615 8.34983 9.15827 8.74765L1.91409 15.1822C1.26911 15.7551 0.250004 15.2972 0.250004 14.4345L0.250002 1.5655C0.250002 0.702824 1.26911 0.244951 1.91409 0.817844L9.15827 7.25235Z" :fill="fill"/>
  </svg>
</template>

<script>
export default {
  name: 'ScrollArrowRight',
  props: {
    width: {
      type: String,
      required: false,
      default: '10'
    },
    height: {
      type: String,
      required: false,
      default: '16'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#222222'
    },
  },
};

</script>
